import { getProductCartItem } from 'core/use-cases/helpers';

import type { Cart } from 'core';
import type { CatalogItem } from 'core/domains/catalog';

type EditCatalogInfos = {
  data: CatalogItem[];
  itemAddCartError: Array<CatalogItem['productCode']>;
  cartData: Cart['data'];
};

export const editCatalogInfos = ({ data, cartData, itemAddCartError }: EditCatalogInfos) => {
  return data.map((catalogItem) => {
    const { productPosition, productOrigin, quantity } = getProductCartItem(
      catalogItem.productCode,
      cartData,
    );

    return {
      ...catalogItem,
      productOrigin,
      productPosition,
      quantity,
      isAvailable: itemAddCartError?.includes(catalogItem.productCode)
        ? false
        : catalogItem.isAvailable,
    };
  });
};
